import { INCIDENT_URL } from "@@/config/Urls";
import { FETCH_INCIDENT_DATA, FETCHED_INCIDENT_DATA } from "@@/constants/IncidentConstants"
import { fetch } from "@selkirk-systems/fetch";
import { dispatch, serializeAndRespondWith } from "@selkirk-systems/state-management";

export const fetchIncidentData = ()=>{

    dispatch(FETCH_INCIDENT_DATA);

    return fetch(INCIDENT_URL()).then(serializeAndRespondWith(FETCHED_INCIDENT_DATA))
    
}